import EXPERT_TYPES from "./expertTypes";

export default value => {
    const data = EXPERT_TYPES.find((i) => i.value === value);

    return data ? data.text : "N/A";
}
